/_ An enum that define all screen sizes the application support _/;
export enum SCREEN_SIZE {
  XS = 'XS',
  SM = 'SM',
  MD = 'MD',
  LG = 'LG',
  XL = 'XL',
}

export enum BRANDS {
  KWIKSETUNITE = 'kwiksetunite',
  WEISER = 'weiser',
}

export enum LANGUAGES {
  ENGLISH = 'en-us',
  FRENCH = 'fr-ca',
}